module.exports = __webpack_public_path__ + "img/缅茄.74be6b16.jpg";